import { render } from "./GameCondition.vue?vue&type=template&id=5482c470"
import script from "./GameCondition.vue?vue&type=script&lang=js"
export * from "./GameCondition.vue?vue&type=script&lang=js"

import "./GameCondition.vue?vue&type=style&index=0&id=5482c470&lang=scss"

import exportComponent from "/builds/chatplace/app-gamification/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__